import PageContainer from '@/common/components/PageContainer'
import { AdminUpdateOperatorForm } from '@/modules/admin/components/AdminUpdateOperatorForm'
import { AdminResetPasswordOperatorForm } from '@/modules/admin/components/AdminResetPasswordOperatorForm'
import { useParams } from 'react-router-dom'

export default function UpdateOperatorPage() {
	const { id } = useParams()
	return (
		<PageContainer>
			<div className="flex-1 space-y-4">
				<AdminUpdateOperatorForm operatorId={id!} />
				<AdminResetPasswordOperatorForm operatorId={id!} />
			</div>
		</PageContainer>
	)
}
